import React from 'react';
import { CardActions } from 'material-ui/Card';
import { ListButton, ShowButton, DeleteButton } from '../button';

const cardActionStyle = {
  zIndex: 2,
  display: 'inline-block',
  float: 'right',
};

function EditActions({ basePath, showPath, data, hasDelete, hasShow }) {
  return (
    <CardActions style={cardActionStyle}>
      {!!hasShow && (
        <ShowButton linkTo={basePath} showPath={showPath} record={data} />
      )}

      <ListButton basePath={basePath} />

      {!!hasDelete && (
        <DeleteButton basePath={basePath} record={data} />
      )}
    </CardActions>
  );
}

export default EditActions;



// WEBPACK FOOTER //
// ./src/components/detail/EditActions.js